import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "form-field__label--text" }
const _hoisted_2 = {
  key: 0,
  class: "form-field__label--required"
}
const _hoisted_3 = { class: "form-field__label--end" }
const _hoisted_4 = { class: "form-field__value" }

import { FieldWrapper as KFieldWrapper } from '@progress/kendo-vue-form';
import { Error as KError, Hint as KHint, Label as KLabel } from '@progress/kendo-vue-labels';
import { TextArea as KTextArea } from '@progress/kendo-vue-inputs';
import { ModelRef } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormTextArea',
  props: /*@__PURE__*/_mergeModels({
  disabled: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: undefined,
  },
  isValid: {
    type: Boolean,
    default: true,
  },
  isRequired: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: undefined,
  },
  link: {
    type: String,
    default: undefined,
  },
  validationMessage: {
    type: [String, null],
    default: undefined,
  },
  hintMessage: {
    type: String,
    default: undefined,
  },
  width: {
    type: String,
    default: '230px',
  },
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props) {

const props = __props;

const model: ModelRef<string | number | undefined> = _useModel(__props, "modelValue") as ModelRef<
  string | number | undefined
>;
function handleChange() {}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KFieldWrapper), { class: "form-field" }, {
    default: _withCtx(() => [
      (__props.label)
        ? (_openBlock(), _createBlock(_unref(KLabel), {
            key: 0,
            class: _normalizeClass('form-field__label'),
            "editor-valid": __props.isValid,
            disabled: __props.disabled
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_1, [
                _createTextVNode(_toDisplayString(__props.label) + " ", 1),
                (__props.isRequired)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "*"))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", _hoisted_3, [
                _renderSlot(_ctx.$slots, "label-end")
              ])
            ]),
            _: 3
          }, 8, ["editor-valid", "disabled"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(KTextArea), _mergeProps(_ctx.$attrs, {
          modelValue: model.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
          style: { width: props.width },
          valid: __props.isValid,
          disabled: __props.disabled,
          placeholder: __props.placeholder,
          onInput: handleChange
        }), null, 16, ["modelValue", "style", "valid", "disabled", "placeholder"]),
        (__props.validationMessage)
          ? (_openBlock(), _createBlock(_unref(KError), {
              key: 0,
              class: "form-field__errors"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.validationMessage), 1)
              ]),
              _: 1
            }))
          : (__props.hintMessage)
            ? (_openBlock(), _createBlock(_unref(KHint), { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.hintMessage), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }))
}
}

})